/*
 * @Date: 2022-12-07 16:31:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-28 13:46:24
 * @FilePath: /shoplus-global-website-node/pages/index.tsx
 */
import { NextPage } from 'next'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { watchDom } from '@/watch'
import {
  getGoodsTrendChart,
  getGoodsTrend,
  getPayDiscountInfoUnToken,
  getPayDiscountInfo,
  getCurrentCombo
} from '@/service/index'
import { useEffect, useMemo, useRef, useState } from 'react'
import Layout from '@/components/layout'
import { useWidth } from '@/utils/resize'
import dynamic from 'next/dynamic'
import { GetServerSideProps } from 'next'
import { setCookie, getCookie } from 'cookies-next'
import DiscountDrawer from '@/components/discountDrawer'
import GiftBagsDialog from '@/components/homeV3/mobile/mBanner/components/giftBagsDialog'
import Cookies from 'js-cookie'

let watchDoms: any = ''

const MBanner = dynamic(import('@home3/mobile/mBanner'))
const MCopyNotice = dynamic(import('@home3/mobile/mCopyNotice'))
const MTag = dynamic(import('@home3/mobile/mtag'))
const MEcomTrend = dynamic(import('@home3/mobile/mEcom'))
const MGoodRanking = dynamic(import('@home3/mobile/mGoodRanking'))
const MGoodsVideo = dynamic(import('@home3/mobile/mGoodVideo'))
// const MContent = dynamic(import("@/components/homeV3/mobile/mContent"));
const MInfluencer = dynamic(import('@/components/homeV3/mobile/mInflucer'))
const Notice = dynamic(import('@/components/notice'))
const Home: NextPage<{
  context: any
  goodsVideoData: any
  trendData: any
  trendChart: any
  PageContext: any
  bannerList: any[]
  discountInfo: any
  userComboInfo: any
}> = (props) => {
  const router = useRouter()
  // const { locale } = router;
  const { width, display } = useWidth()
  const isPc = width >= 1024
  const dom: any = useRef()
  // const watchData: any = "";
  const [init, setInit] = useState(false)
  const [trendChart, setTrendChart] = useState(undefined)
  const [trendData, setTrendData] = useState(undefined)
  const [offsetBanner, setOffsetBanner] = useState(false)
  const [copyVisible, setCopyVisible] = useState(false)
  let { context } = props
  // 获取滚动高度
  const checkOffsetNotice = (event) => {
    if (event.target.body) {
      const st =
        (event.srcElement ? event.srcElement.scrollTop : false) ||
        window.pageYOffset ||
        (event.srcElement ? event.srcElement.body?.scrollTop : false)
      setOffsetBanner(st >= 200 - 70)
    }
  }
  // 检查当前同志是否打开
  const checkedCLinkTip = () => {
    let curDate = new Date()
    let dateStr = `${curDate.getMonth()} ${curDate.getDate()}`
    let showNotice: any = {}
    showNotice = Cookies.get('showCopyNotice')
      ? JSON.parse(Cookies.get('showCopyNotice') as string)
      : ''
    // 如果不是同一天，或者是第一次打开页面，则显示通知
    if (!showNotice || showNotice?.dateStr !== dateStr) {
      let data = { dateStr: dateStr, visible: true }
      setCopyVisible(true)
      const temp = window.location.host.split('.').reverse()
      const root_domain = '.' + temp[1] + '.' + temp[0]
      if (process.env.NODE_ENV !== 'development') {
        Cookies.set('showCopyNotice', JSON.stringify(data), {
          expires: 7,
          domain: root_domain
        })
      } else {
        Cookies.set('showCopyNotice', JSON.stringify(data))
      }
    } else {
      setCopyVisible(showNotice.visible)
    }
  }
  // 关闭通知
  const close = () => {
    setCopyVisible(false)
    const temp = window.location.host.split('.').reverse()
    const root_domain = '.' + temp[1] + '.' + temp[0]
    const data = Cookies.get('showCopyNotice')
      ? JSON.parse(Cookies.get('showCopyNotice') as string)
      : ''
    if (process.env.NODE_ENV !== 'development') {
      Cookies.set('showCopyNotice', JSON.stringify({ ...data, visible: false }), {
        expires: 7,
        domain: root_domain
      })
    } else {
      Cookies.set('showCopyNotice', JSON.stringify({ ...data, visible: false }))
    }
  }
  // console.log(goodsVideoData);
  useEffect(() => {
    //  TODO:  商品趋势图表
    let trendDataInfo: any = undefined
    let Trends: any = undefined
    let trendChartInfo: any = undefined
    if (!init) {
      const trendReq = async () => {
        trendChartInfo = await getGoodsTrendChart(context)
        Trends = await getGoodsTrend(context)
        setTrendChart(trendChartInfo)
        if (Trends && Trends.code == 0) {
          trendDataInfo = Trends.data
          setTrendData(trendDataInfo)
        }
        setInit(true)
      }
      trendReq()
    }
    checkedCLinkTip()
  }, [])

  useEffect(() => {
    // if (process.browser) {
    //   if (dom.current) {
    //     if (watchDoms) clearInterval(watchDoms)
    //     watchDoms = watchDom({ trendData, trendChart })
    //   }
    // }
    window.addEventListener('scroll', checkOffsetNotice, true)
    return function cleanup() {
      window.removeEventListener('scroll', checkOffsetNotice)
    }
  }, [dom, init])

  const isShowGiftBagsDialog = useMemo(() => {
    if (props.discountInfo.type !== 6) return false
    console.log('props?.discountInfo~', props?.discountInfo)
    console.log('props.userComboInfo~', props.userComboInfo)

    if (!props?.discountInfo?.usable && props.userComboInfo?.id) return false
    return true
  }, [props.discountInfo, props.userComboInfo])

  return (
    <div>
      <Layout
        data={{ trendData, trendChart }}
        header={true}
        footer={true}
        footerBtns={true}
        isHome={true}
        userComboInfo={props.userComboInfo}
      >
        <Head>
          <link rel="canonical" href={`https://www.shoplus.net/`} />
          <title>TikTok Analytics | Influencer Marketing Platform | Shoplus</title>
          <meta
            name="keywords"
            content="TikTok analytics tool, influencer marketing platform"
          ></meta>
          <meta
            name="description"
            content="Shoplus is a TikTok analytics tool, search for popular TikTok videos, music, ads and top TikTok influencers. Let you get more followers and boost your business."
          />
          <script src="/js/bounty.js" async />
          <script src="/js/jq.js" async />
          <script src="/js/jq.number.js" async />
          <script src="/js/g2.js" async />
        </Head>

        <div ref={dom} id="moblieMain">
          {/* 手机端 */}
          <Notice />
          <MBanner bannerList={props.bannerList} info={props.discountInfo} />
          {offsetBanner && copyVisible ? <MCopyNotice close={close} /> : null}
          <MTag />
          <MEcomTrend />
          <MGoodRanking />
          <MGoodsVideo />
          <MInfluencer></MInfluencer>
          {props?.discountInfo?.type !== 6 ? <DiscountDrawer /> : null}
          {isShowGiftBagsDialog ? <GiftBagsDialog /> : null}
        </div>
      </Layout>
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  setCookie('LOCAL_UA', context.req.headers['user-agent'], {
    req: context.req,
    res: context.res
  })
  const { locale } = context

  const authorizedToken = context?.req?.cookies?.['authorized-token'] || '{}'
  const token = JSON.parse(authorizedToken)?.accessToken
  const isAuth = !!token
  const params = {
    systemId: 14,
    marketingType: 6,
    deviceId: getCookie('BURIEDSDK_DEVICEID')
  }
  let userComboInfo = {} // 用户套餐信息
  if (isAuth) {
    const res = await getCurrentCombo(14, token)
    userComboInfo = res?.data?.[0] ?? {}
  }

  const fn = isAuth
    ? getPayDiscountInfo(params.systemId, params.marketingType, params.deviceId, token)
    : getPayDiscountInfoUnToken(params)
  const infoData = await fn

  let discountInfo = {}
  let bannerList: Array<any> = []

  if (infoData && infoData.data && infoData.data.length) {
    bannerList = [
      {
        type: 'mActivity',
        url: 'https://mcdn.shoplus.net/custom/images/activity/giftActivity/m_banner.png'
      }
    ]
    discountInfo = infoData.data.sort((a, b) => {
      return a.actualAmount - b.actualAmount
    })[0]
  }
  return {
    props: {
      ...(await serverSideTranslations(context.locale as string, [
        'home',
        'common',
        'nav',
        'footer'
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers
        }
      },
      bannerList,
      discountInfo,
      userComboInfo
    }
  }
}
export default Home
